//@ts-nocheck
import React from 'react'
import T from 'prop-types'
import { Text } from '@wework/dieter-ui'
import { Loader } from 'semantic-ui-react'

const LoadingPlaceholder = ({ background, text = '' }) => {
  return (
    <div
      style={{
        background,
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <Loader active size="medium">
        {text && <Text size="small">{text}</Text>}
      </Loader>
    </div>
  )
}

LoadingPlaceholder.propTypes = {
  background: T.string,
}

LoadingPlaceholder.defaultProps = {
  background: 'rgba(255, 255, 255, 0.6)',
}

export default LoadingPlaceholder
